export default "__VITE_ASSET__COti39Ta__"